/* eslint-disable no-nested-ternary */
import React from 'react'

import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import { ColumnGroup } from 'primereact/columngroup'
import { Row } from 'primereact/row'
import DeleteButton from '../common/buttons/DeleteButton'
import DataTableComp from '../common/data-table/DataTableComp'
import { DataTableFun } from '../../utils/helpers/dataTableFun'

const DataTableWorkerProjects = ({
  data,
  loading = false,
  showHeaders = true,
  showWhenNoData = false,
  footerGroup,
  handleDelete,
}) => {
  const { formatMessage: msg } = useIntl()

  const buttonDelete = (rowData) => {
    return (
      <DeleteButton
        isDisabled={loading}
        onClick={() => handleDelete(rowData)}
      />
    )
  }

  const columns = () => {
    const commonColumns = [
      <Column
        field="code"
        sortable={data?.length > 1}
        style={{ width: '60%' }}
        body={(rowData) => String(rowData.code || '')}
        header={showHeaders && msg({ id: 'project' })}
      />,
      <Column
        field="percentage"
        sortable={data?.length > 1}
        style={{ width: '30%' }}
        align="right"
        body={(rowData) => `${rowData?.percentage}%`}
        header={showHeaders && msg({ id: 'distribution' })}
      />,
    ]
    return handleDelete
      ? [
          ...commonColumns,
          <Column field="_id" body={(rowData) => buttonDelete(rowData)} />,
        ]
      : commonColumns
  }

  return (data && data.length > 0) || showWhenNoData ? (
    <DataTableComp
      disableAutoheight
      style={{ width: '100%' }}
      tableOptions={{
        showHeaders,
        value: data,
        responsiveLayout: 'scroll',
        scrollable: true,
        scrollHeight: DataTableFun.responsiveHeight(),
        footerColumnGroup: footerGroup || undefined,
      }}
      autoColumnKey
      columns={columns()}
    />
  ) : null
}

export default DataTableWorkerProjects
